var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrectPalm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 238,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.77 150.564c1.397 29.159 25.259 52.437 54.398 52.437 29.139 0 53.001-23.287 54.397-52.437H17.771z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.65 114.132c-10.247 7.686-7.686 25.618-7.686 38.427l11.529 10.248 32.022 3.843 39.707-1.281c6.405.427 19.213-1.793 19.213-14.09 0-15.37-6.404-16.653-33.303-35.866-26.898-19.213-51.235-8.966-61.482-1.281z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.998 92.36v57.639c-2.562 2.989-8.967 7.685-14.09 2.562-6.404-6.405-7.685-8.967-7.685-21.775v-28.18c0-12.809 10.247-17.932 15.37-17.932 5.124 0 6.405 2.562 6.405 7.685z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.498 149.999a2.5 2.5 0 1 0 5 0h-5zm-21.775-19.213a2.5 2.5 0 0 0 5 0h-5zm26.775 19.213V92.359h-5V150h5zm0-57.64c0-2.623-.294-5.28-1.781-7.264-1.633-2.177-4.183-2.921-7.124-2.921v5c2.183 0 2.836.537 3.124.921.434.579.781 1.764.781 4.264h5zm-8.905-10.185c-3.243 0-7.667 1.554-11.279 4.804-3.704 3.335-6.591 8.483-6.591 15.628h5c0-5.663 2.236-9.481 4.936-11.911 2.793-2.513 6.054-3.521 7.934-3.521v-5zm-17.87 20.432V130.786h5V102.606h-5z",
    fill: "#DEE5F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.223 44.965v85.82c0 1.707-2.306 5.123-11.528 5.123-11.528 0-8.966-20.494-8.966-29.46V43.685c0-5.124 3.843-10.248 10.247-10.248s10.247 5.124 10.247 11.528z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.223 130.785v-85.82c0-6.404-3.843-11.528-10.247-11.528-6.405 0-10.248 5.124-10.248 10.248v62.763",
    stroke: "#DEE5F8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.728 34.72v71.729c0 4.696-1.793 14.089-8.966 14.089-8.966 0-11.528-7.685-11.528-15.37v-71.73c0-8.966 7.686-10.247 10.247-10.247 2.562 0 10.248 2.562 10.248 11.528z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.728 106.449v-71.73c0-8.966-7.685-11.528-10.247-11.528-2.561 0-10.247 1.281-10.247 10.247v73.011",
    stroke: "#DEE5F8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.234 46.246v60.202c0 11.528-5.123 15.37-11.528 15.37-6.404 0-10.247-2.561-10.247-15.37V46.246c0-7.685 3.843-12.809 10.247-12.809s11.528 3.843 11.528 12.81z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.234 106.448V46.246c0-8.966-5.123-12.809-11.528-12.809-6.404 0-10.247 5.124-10.247 12.81v60.201",
    stroke: "#DEE5F8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.46 70.583v35.864c0 10.247 0 21.775-10.247 23.056-8.198 1.025-10.247-7.258-10.247-11.528V69.302c0-5.124 3.842-10.247 10.247-10.247 6.404 0 10.247 5.123 10.247 11.528z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.46 106.447V70.583c0-6.405-3.843-11.528-10.247-11.528-6.405 0-10.247 5.123-10.247 10.247v48.673",
    stroke: "#DEE5F8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.166 197.941c-26.396 0-48.199-21.071-49.605-47.418h-4.97c1.396 29.159 25.436 52.478 54.575 52.478 29.14 0 53.874-23.854 55.27-53.003h-5c-1.377 26.377-23.873 47.943-50.27 47.943z",
    fill: "#DEE5F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.965 151.28v-33.303",
    stroke: "#DEE5F8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 138,
    height: 232,
    rx: 6,
    stroke: "#9BACD7",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3 210h138v19a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6v-19zM3 9a6 6 0 0 1 6-6h126a6 6 0 0 1 6 6v7H3V9z",
    fill: "#9BACD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 224,
    r: 7,
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectPalm);
export default __webpack_public_path__ + "static/media/correct-palm.9a2c45712cdce3945d68c1c974d20663.svg";
export { ForwardRef as ReactComponent };